import { TitleCreateTestType } from 'src/redux/features/surveys/titleCreateTest/types';

export function formatDate(date: Date): string {
  let dd: string = String(date.getDate());
  if (+dd < 10) dd = `0${dd}`;

  let mm: string = String(date.getMonth() + 1);
  if (+mm < 10) mm = `0${mm}`;

  const yy: string = String(date.getFullYear());

  return `${dd}.${mm}.${yy}`;
}

export const breadCreateTest = (
  isQuestion: boolean,
  titleCreateTest: TitleCreateTestType,
) => {
  if (isQuestion) {
    const newBread = [
      {
        name: 'Главная страница',
        pathname: '/dashboard',
      },
      {
        name: titleCreateTest.name,
        isProps: true,
        pathname: '',
      },
      {
        name: 'Добавление вопроса',
        pathname: 'a',
        isActive: true,
      },
    ];
    return newBread;
  } else {
    const newBread = [
      {
        name: 'Главная страница',
        pathname: '/',
      },
      {
        name: titleCreateTest.name,
        pathname: '',
        isActive: true,
      },
    ];
    return newBread;
  }
};

export function plural(number: number, titles: Array<string>): string {
  /*
    EXAMPLE: plural(2, ['балл', 'балла', 'баллов']) -> 'баллов'
  */
  const cases = [2, 0, 1, 1, 1, 2];
  return titles[
    number % 100 > 4 && number % 100 < 20
      ? 2
      : cases[number % 10 < 5 ? number % 10 : 5]
  ];
}

export const compareDay = (first: Date, second: Date): boolean => {
  return first.toLocaleDateString() === second.toLocaleDateString();
};
